module.exports = __webpack_public_path__ + "static/media/IMG_20190615_184528.4f48234e.jpg";